export enum ActivistInvestorType {
  Often = 'Often',
  Occasional = 'Occasional'
}
